// Shared goalkeeper KPI thresholds and interpretations.
// Used by match report detail KPIs, alerts, and other coach tooling.

export const GOALKEEPER_KPI_CONFIG = {
	finalRating: {
		type: "score10",
		label: "Valutazione finale",
		priority: "primary",
		thresholds: {
			good: 7.5, // >= good
			avg: 6.0, // >= avg and < good
		},
		interpretation: {
			good: "Buono",
			avg: "Nella media",
			poor: "Critico",
		},
	},
	shotStopping: {
		type: "ratio",
		label: "Indice parate",
		priority: "primary",
		thresholds: {
			good: 0.8,
			avg: 0.6,
		},
		interpretation: {
			good: "Buono",
			avg: "Nella media",
			poor: "Critico",
		},
	},
	distribution: {
		type: "ratio",
		label: "Efficienza distribuzione",
		priority: "secondary",
		thresholds: {
			good: 0.75,
			avg: 0.6,
		},
		interpretation: {
			good: "Efficace",
			avg: "Discontinuo",
			poor: "Da migliorare",
		},
	},
	aerialControl: {
		type: "ratio",
		label: "Controllo aereo",
		priority: "secondary",
		thresholds: {
			good: 0.75,
			avg: 0.6,
		},
		interpretation: {
			good: "Sicuro",
			avg: "Incerto",
			poor: "Debole",
		},
	},
	setPieces: {
		type: "ratio",
		label: "Controllo su palle inattive",
		priority: "secondary",
		thresholds: {
			good: 0.9,
			avg: 0.8,
		},
		interpretation: {
			good: "Controllo alto",
			avg: "Controllo medio",
			poor: "Rischioso",
		},
	},
	errorImpact: {
		type: "ratioLowerIsBetter",
		label: "Impatto errori",
		priority: "primary",
		thresholds: {
			good: 0.15, // <= good
			avg: 0.3, // <= avg and > good
		},
		interpretation: {
			good: "Pulito",
			avg: "Qualche errore",
			poor: "Errori gravi",
		},
	},
};

